import React from 'react'
import { Link } from 'gatsby'

const Breadcrumb = ({ breadcrumbs }) => {
  const [last, ...bc] = breadcrumbs.reverse()

  return (
    <nav className="breadcrumb has-succeeds-separator">
      <div className="container is-fluid">
        <ul>
          {bc.reverse().map(({ target, display, keep }, i) => (
            <li key={i}>
              {keep && <a href={target}>{display}</a>}
              {!keep && <Link to={target}>{display}</Link>}
            </li>
          ))}

          <li>{last.display}</li>
        </ul>
      </div>
    </nav>
  )
}

export default Breadcrumb
